<div class="flex flex-col gap-2 pb-4" *transloco="let t">
  <!-- Header with timestamp and visibility -->
  <div class="flex flex-row gap-2 items-center">
    <span class="text-mbaza-gray text-xs font-light">
      @if (followUp.createdAt) {
      {{ followUp.createdAt | date : "dd MMM yyyy" }} -
      {{ followUp.createdAt | date : "HH:mm" }}
      } @else {
      <span class="text-gray-400">{{t('noTimestamp')}}</span>
      }
    </span>
    @if (followUp.visibility === 'PRIVATE') {
    <span
      class="text-mbaza-primary bg-mbaza-primary/10 rounded-xl px-3 py-0.5 text-xs font-semibold italic"
    >
      Private
    </span>
    }
  </div>

  <!-- Content based on action type -->
  @switch (followUp.action) { @case ("REPORTED_COMPLAINT") {
  <span class="text-sm md:text-base">
    <span class="text-black font-semibold">
      {{ followUp.actionMetadata.reportedBy }}
    </span>
    {{t('reportedAComplaint')}}
  </span>
  } @case ("CREATED_CASE") {
  <span class="text-sm md:text-base">
    <span class="text-black font-semibold">
      {{ followUp.userDetails?.trackingLevel }} - {{followUp.userDetails?.occupation}}
    </span>
    {{t('createdACase')}}
  </span>
  } @case ("ESCALATED_CASE") {
  <span class="text-sm md:text-base">
    <span class="text-black font-semibold">
      {{ followUp.userDetails?.trackingLevel }}
    </span>
   {{t('escalated')}}
    <span class="text-black font-semibold">
      {{ followUp.actionMetadata.trackingLevel }}
    </span>
    level in {{ followUp.actionMetadata.primaryInstitutionName }}.
  </span>
  } @case ("ADDED_NOTE") {
  <span class="text-sm md:text-base">
    <span class="text-black font-semibold">
      {{ followUp.userDetails?.trackingLevel }} -
      {{ followUp.userDetails?.occupation}}
    </span>
  </span>
  <span class="text-black text-sm md:text-base">
    {{ followUp.actionMetadata.comment }}
  </span>

  <!-- FIXED: Direct access to supportingDocuments array -->
  @if (followUp.actionMetadata.supportingDocuments &&
  followUp.actionMetadata.supportingDocuments.length > 0) {
  <div class="flex flex-row gap-2 flex-wrap">
    @for (document of followUp.actionMetadata.supportingDocuments; track
    document) { @if (document && document.url && document.filename) { @if
    (isImageDocument(document)) {
    <img
      [src]="document.url"
      [alt]="document.filename"
      class="w-16 h-16 md:w-20 md:h-20 rounded-sm"
    />
    } @else {
    <div
      class="flex flex-row gap-2 items-center cursor-pointer"
      (click)="onDownloadDocument(document)"
      (keydown.enter)="onDownloadDocument(document)"
      tabindex="0"
    >
      <nz-icon nzType="paper-clip" />
      <span class="font-light text-sm md:text-base">{{
        document.filename
      }}</span>
    </div>
    } } }
  </div>
  } }
  <!--        TODO:  For GGO Condition-->
  @case ("CLOSED_CASE") {
  <span class="text-sm md:text-base">
    <span class="text-black font-semibold">
      {{ followUp.userDetails?.trackingLevel }} -
      {{ followUp.userDetails?.occupation}}
    </span>
    {{t('theCaseWasMarkedAs')}}
    <span class="text-black font-semibold">{{ t('closed') }}.</span>
  </span>
  <span class="text-black text-sm md:text-base">
    {{ followUp.actionMetadata.comment }}
  </span>
  } @case ("RESOLVED") {
  <span class="text-sm md:text-base">
    <span class="text-black font-semibold">
     {{ followUp.userDetails?.trackingLevel }} -
      {{ followUp.userDetails?.occupation}}
    </span>
    {{t('theCaseWasMarkedAs')}}
    <span class="text-black font-semibold">{{ t('done') }}.</span>
  </span>
  <span class="text-black text-sm md:text-base">
    {{ followUp.actionMetadata.comment }}
  </span>
  } @case ("REOPENED_CASE") {
  <span class="text-sm md:text-base">
    <span class="text-black font-semibold">
       {{ followUp.userDetails?.trackingLevel }} -
      {{ followUp.userDetails?.occupation}}
    </span>
    {{t('theCaseWasMarkedAs')}}
    <span class="text-black font-semibold">{{ t('reopened') }}</span>
  </span>
  } @case ("INVITED_TO_CASE") { @if (followUp.actionMetadata.invitedBy) {
  <span class="text-black font-semibold text-sm md:text-base">
    {{ followUp.actionMetadata.invitedBy }}
    <span class="font-normal">{{t('escalated')}}</span>
   Your institution
  </span>
  <div class="w-full flex flex-col sm:flex-row gap-2 sm:gap-4">
    <app-mb-button
      [type]="'destructive'"
      [label]="'Reject'"
      (clickHandler)="showRejectInvitationModal()"
    />
  </div>
  } } }
</div>

<!-- modal  -->
<nz-modal
  [nzContent]="modalContent"
  [nzFooter]="null"
  [nzVisible]="isStatusModalVisible"
  [nzClosable]="false"
  [nzWidth]="'90%'"
  [nzStyle]="{ maxWidth: '500px' }"
></nz-modal>
<ng-template #modalContent >
  <div class="flex items-center justify-between"  *transloco="let t">
    <p class="font-black uppercase text-sm">
      {{ statusModalTitle }}
    </p>
    <p
      class="text-mbaza-text-primary"
      (click)="handleStatusModalCancel()"
      (keydown.enter)="handleStatusModalCancel()"
      (keydown.space)="handleStatusModalCancel()"
      aria-label="Close Status Modal"
      tabindex="0"
    >
      <img
        [src]="ASSET_CONSTANTS.I_cancel"
        alt="close icon"
        height="24"
        width="24"
        class="transition-discrete duration-300 grayscale"
      />
    </p>
  </div>
  <div class="flex flex-col mt-4"  *transloco="let t">
    <p class="font-semibold text-sm md:text-base">{{t('comment')}}</p>
    <textarea
      placeholder="Add a comment"
      class="w-full bg-white resize-none outline-none items-center h-full p-2 border placeholder:text-mbaza-gray border-mbaza-gray-dark rounded-sm text-sm md:text-base"
      rows="4"
      [(ngModel)]="statusComment"
    ></textarea>
    <div class="flex justify-end mt-4">
      <app-mb-button
        [disabled]="statusComment === ''"
        [type]="'secondary'"
        [label]="statusModalTitle"
        class="w-1/2"
      />
    </div>
  </div>
</ng-template>
